<bt-label-design [model]="model" [value]="model.value"></bt-label-design>